import React from "react";
import { DialogTitle as MUIDialogTitle } from "@mui/material";
import styled from "styled-components";

const StyledMUIDialogTitle = styled(MUIDialogTitle)`
  .MuiTypography-root {
    font-weight: 600 !important;
  }

  font-family: var(--primaryFont) !important;
  font-weight: 600 !important;
  text-transform: unset !important;
  font-size: 25px !important;
`;

export const DialogTitle = (props) => {
  return <StyledMUIDialogTitle {...props} />;
};
